;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';

import FileUploadButton from './FileUploadButton';
import getFileIcon from '../utils/getFileIcon';
import { getI18nUtils } from '../i18n/i18n-utils';

interface ResumeUploadFieldProps {
  candidate: Candidate;
  handleCvUpload: (uploadEvent: React.ChangeEvent<HTMLInputElement>) => void;
  allowedCvFileTypes: string[];
  valid: boolean;
  invalid: boolean;
  id?: string;
  name?: string;
  dictionary: Record<string, string>;
}

function ResumeUploadField({
  candidate,
  handleCvUpload,
  allowedCvFileTypes,
  valid,
  invalid,
  id = 'cvUpload',
  name = 'cvUpload',
  dictionary,
}: ResumeUploadFieldProps) {
  const { formatMessage } = getI18nUtils(dictionary);

  return (
    <FormGroup>
      {candidate?.cv ? (
        <>
          <Label className="text-muted">{formatMessage({ id: 'attachment-added' })}</Label>
          <FormGroup className="form-group">
            {getFileIcon(
              {
                className: 'position-absolute m-2 fileUploadIcon success',
                size: 24,
              },
              candidate.cvName
            )}
            <Input type="text" className="ps-5" value={candidate.cvName ?? ''} disabled />
          </FormGroup>
        </>
      ) : (
        <>
          <FileUploadButton
            changed={handleCvUpload}
            fileTypes={allowedCvFileTypes.join(',')}
            id={id}
            name={name}
            labelName="apply-form-filetitle"
            invalid={!!invalid}
            valid={!!valid}
            dictionary={dictionary}
          />
          <FormFeedback>{formatMessage({ id: 'file-extension-not-allowed-for-upload' })}</FormFeedback>
        </>
      )}
    </FormGroup>
  );
}

export default ResumeUploadField;
